/* SNAIL CURVE · JS común
   - Aparición al scroll (.reveal) con el mismo escalonado del original
   - Compra AJAX (JSON -> FormData -> formulario nativo) con la variante del color activo
   - Capa de medición (dataLayer / Plausible / gtag), portada de analytics.js
*/
(function () {
  if (window.SNC && window.SNC.__ready) return;
  var SNC = window.SNC = window.SNC || {};
  SNC.__ready = true;
  SNC.state = SNC.state || { color: null };
  var REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  SNC.reduced = REDUCED;

  /* ---------------- Aparición ---------------- */
  var SEL = '.statement, .substatement, .lead, .prebanner, .tile, .stat, .boxitem, .model, .caption, .morelink, .forat, .speed, .chips';
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) { return c.classList.contains('reveal'); });
      var off = parseInt(el.parentElement.getAttribute('data-rv-offset') || '0', 10);
      el.style.transitionDelay = REDUCED ? '0s' : Math.min(sibs.indexOf(el) + off, 5) * 150 + 'ms';
      el.classList.add('in');
      io.unobserve(el);
    });
  }, { threshold: 0.16 });
  SNC.reveal = function (root) {
    (root || document).querySelectorAll('[data-snc] ' + SEL.split(', ').join(', [data-snc] ')).forEach(function (el) {
      if (el.closest('[data-snc-noreveal]')) return;
      if (el.classList.contains('in')) return;
      el.classList.add('reveal');
      if (document.documentElement.classList.contains('shopify-design-mode')) { el.classList.add('in'); return; }
      io.observe(el);
    });
  };
  function fallbackReveal() {
    document.querySelectorAll('.reveal:not(.in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.92 && r.bottom > 0) { el.classList.add('in'); io.unobserve(el); }
    });
  }
  addEventListener('scroll', fallbackReveal, { passive: true });

  /* ---------------- Producto y compra ---------------- */
  SNC.product = function () {
    if (SNC._p !== undefined) return SNC._p;
    var n = document.querySelector('script[data-snc-product]');
    try { SNC._p = n ? JSON.parse(n.textContent) : null; } catch (e) { SNC._p = null; }
    return SNC._p;
  };
  SNC.config = function () {
    var n = document.querySelector('[data-snc-after-add]');
    return { afterAdd: n ? n.getAttribute('data-snc-after-add') : 'drawer' };
  };
  SNC.pickVariant = function (color) {
    var p = SNC.product();
    if (!p || !p.variants || !p.variants.length) return null;
    var want = (color || SNC.state.color || '').toString().trim().toLowerCase();
    var vs = p.variants;
    if (want) {
      var byColor = vs.filter(function (v) {
        return (v.options || []).some(function (o) { return String(o).trim().toLowerCase() === want; });
      });
      var ok = byColor.filter(function (v) { return v.available; });
      if (ok.length) return ok[0];
      if (byColor.length) return byColor[0];
    }
    var sel = vs.filter(function (v) { return v.id === p.selected; })[0];
    if (sel && sel.available) return sel;
    return vs.filter(function (v) { return v.available; })[0] || vs[0];
  };
  function toast(msg) {
    var t = document.querySelector('.snc-toast');
    if (!t) { t = document.createElement('div'); t.className = 'snc-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('on'); }, 3200);
  }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function addJSON(id, qty) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); });
  }
  function addForm(id, qty) {
    var fd = new FormData(); fd.append('id', id); fd.append('quantity', qty);
    return fetch(root() + 'cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); });
  }
  function addNative(id, qty, after) {
    var f = document.createElement('form');
    f.method = 'post'; f.action = root() + 'cart/add';
    f.innerHTML = '<input type="hidden" name="id" value="' + id + '"><input type="hidden" name="quantity" value="' + qty + '">' +
      (after === 'checkout' ? '<input type="hidden" name="return_to" value="/checkout">' : '');
    document.body.appendChild(f); f.submit();
  }
  SNC.buy = function (btn) {
    var v = SNC.pickVariant();
    if (!v) { toast('Product not available'); return; }
    if (!v.available) { toast('Sold out in this finish'); return; }
    var after = (btn && btn.getAttribute('data-after')) || SNC.config().afterAdd;
    btn && btn.classList.add('is-loading');
    var done = function () {
      var drawer = document.querySelector('[data-cart-drawer]');
      if (after === 'checkout') { location.href = root() + 'checkout'; return; }
      if (after === 'cart' || (after === 'drawer' && !drawer)) { location.href = root() + 'cart'; return; }
      btn && btn.classList.remove('is-loading');
      /* El header del tema escucha cart:added: abre su drawer y lo repinta */
      document.dispatchEvent(new CustomEvent('cart:added', { bubbles: true, detail: { variantId: v.id } }));
      if (after === 'event' || !drawer) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        toast('Added to bag');
      }
    };
    addJSON(v.id, 1).then(done).catch(function (err) {
      if (err && err.status === 422) { btn && btn.classList.remove('is-loading'); toast(err.description || 'Sold out'); return; }
      addForm(v.id, 1).then(done).catch(function () { addNative(v.id, 1, after); });
    });
  };
  /* La bolsa de la landing abre el drawer del tema si existe */
  document.addEventListener('click', function (e) {
    var bag = e.target.closest('[data-snc-bag]');
    if (!bag) return;
    var opener = document.querySelector('.snc-cart-host [data-open-cart]');
    if (!opener) return;
    e.preventDefault();
    opener.click();
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-snc-buy]');
    if (!b) return;
    e.preventDefault();
    SNC.buy(b);
  });

  /* ---------------- Medición (portado de analytics.js) ---------------- */
  var dl = window.dataLayer = window.dataLayer || [];
  var track = SNC.track = function (name, props) {
    dl.push(Object.assign({ event: name }, props || {}));
    if (typeof window.plausible === 'function') window.plausible(name, { props: props });
    if (typeof window.gtag === 'function') window.gtag('event', name, props || {});
  };
  function initTracking() {
    var secs = document.querySelectorAll('[data-snc-track]');
    var pending = new Set(secs);
    var seen = function (el) { if (pending.has(el)) { pending.delete(el); track('section_view', { section: el.getAttribute('data-snc-track') || el.id }); } };
    var obs = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        var big = e.intersectionRect.height > innerHeight * 0.5;
        if (e.isIntersecting && (e.intersectionRatio >= 0.15 || big)) { obs.unobserve(e.target); seen(e.target); }
      });
    }, { threshold: [0.15, 0.4] });
    secs.forEach(function (s) { obs.observe(s); });
    var last = 0;
    addEventListener('scroll', function () {
      var t = Date.now(); if (t - last < 250) return; last = t;
      pending.forEach(function (el) {
        var r = el.getBoundingClientRect(), vis = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
        if (vis > Math.min(r.height * 0.15, innerHeight * 0.5) && vis > 0) seen(el);
      });
    }, { passive: true });
    var depth = 0;
    addEventListener('scroll', function () {
      var h = document.documentElement.scrollHeight - innerHeight;
      if (h > 0) depth = Math.max(depth, Math.round(scrollY / h * 100));
    }, { passive: true });
    addEventListener('pagehide', function () {
      var d = depth >= 100 ? 100 : depth >= 75 ? 75 : depth >= 50 ? 50 : depth >= 25 ? 25 : 0;
      if (d) track('scroll_depth', { percent: d });
    });
    document.addEventListener('click', function (e) {
      var el = e.target.closest('a,button'); if (!el) return;
      var host = el.closest('[data-snc-track],nav,aside'); var from = host ? (host.getAttribute('data-snc-track') || host.id || 'page') : 'page';
      if (el.matches('[data-snc-buy], a[href$="#buy"]')) track('buy_click', { from: from });
      if (el.matches('.colornav .cn')) track('color_select', { color: el.dataset.c });
      if (el.matches('.selchip')) track('speed_select', { level: el.dataset.v || el.textContent.trim() });
      if (el.matches('[data-snc-rabbit-open]')) track('compare_rabbit_open', {});
      if (el.matches('[data-ab="rabbit"]')) track('compare_rabbit_toggle', { side: 'rabbit' });
      if (el.matches('[data-ab="curve"]')) track('compare_rabbit_toggle', { side: 'slidenroll' });
      if (el.matches('.aap')) track('compare_models_open', {});
      if (el.matches('.cv-open')) track('closer_card_open', { card: el.dataset.i });
      if (el.matches('.watchlink')) track('watch_video_click', {});
    }, { passive: true, capture: true });
  }

  function boot() { SNC.reveal(); initTracking(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { SNC._p = undefined; SNC.reveal(e.target); });
})();
